"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurDateTree = exports.drawTpp = exports.drawSalesSalesLeader = exports.drawSales = exports.drawQuarter = exports.drawMonthly = exports.drawMoney = exports.drawLineSales = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
var _utils = require("../utils");
var _main = _interopRequireDefault(require("@/main"));
/* eslint-disable */

// TPP 绘图
var drawTpp = exports.drawTpp = function drawTpp($echart, data) {
  var _data$confirmedCount = data.confirmedCount,
    confirmedCount = _data$confirmedCount === void 0 ? 100 : _data$confirmedCount,
    _data$unFinishedCount = data.unFinishedCount,
    unFinishedCount = _data$unFinishedCount === void 0 ? 0 : _data$unFinishedCount,
    _data$tppTargetCount = data.tppTargetCount,
    tppTargetCount = _data$tppTargetCount === void 0 ? 0 : _data$tppTargetCount;
  var unFinishedCountGauge = confirmedCount === 0 && unFinishedCount === 0 ? 1 : unFinishedCount;
  var options = {
    'series': [{
      'name': 'Access From',
      'type': 'pie',
      'radius': ['50%', '69%'],
      'color': ['#004EA8', '#FEDB00'],
      'startAngle': 180,
      'silent': true,
      'itemStyle': {
        'borderRadius': 4
      },
      'label': {
        'show': confirmedCount !== 0 && unFinishedCount === 0,
        'position': 'inner',
        'formatter': '{img|}',
        'rich': {
          'img': {
            'width': 28,
            'height': 28,
            'backgroundColor': {
              'image': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACECAYAAAB/AaI1AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAB8+SURBVHgB7V17lF1ldf/dx8ydR2JiKeRBVhIhbyxaLEFdS0KRKK7Vh61FXavWP3zgqsof1cofFZuH4mpruxCVWpfLiorVgqCA+IJVk0CghQQY8o4hJAGMMZgMeU0yydzTb3/329/sb5/v3MfMZDIznL3Wd8/73nPP+Z393vsAOeWUU0455ZRTTjnllFNOOeWUU0455ZSTpSRJCjTkspnQuti+NCmI/SQVIl9fkFM+3v0mzzdzfE5jkRgsbrEgluWN04BK7aeWC+KYQmT/6Per/SB+U+8/alRETpaYW6invrBq1apCbXXAgexYuXIlXT+/vmBIgChx+yW8KfKbtCGyOs1xeB3t7763HucKOBhyGnkSgAme6GaG5BqSA2R8V/C9AnSFyDlk/V7dfSLbEOGUOZCGS8w55NPq1te7GdGbj+wbiNj38LFCn8oSWcE+EjzqPIHGQMo61xGjV4oIsxfPiYsCixonDgosFtxGL0ISpSWvWLEiMUBIPdX8vW5dEYM/ltJNaLUSW3LBn5c4R0v0u0J8BeJSijcid452E0JKnCjNuVEjSuIWUCZn0NvdtOi28z5+mafi+3g/XldSy/K7gnm1zn/XddddV+Jl+g51TCbXyRCrMdGbUwOKsni+URF9RN5APY3efA2ERiCBABVt14CM/V7su8T5SuCl/lNMfxpJy23CijBlVQVkLnLCU2b3QqywDKObYcWB4QSpi03bBMVuhF0nji2I46x1R9/tfgNCNBZ5nTvW/g35uzQKSg7S8c4yDP4wi0wljnMRpkkqx6ijUPKTr0WC5gZuvsRD7FtyosUPuUzzjZYxKN7kNPqdbio5jV3m9REu5v8fQl1NK+dRHe0VR3WsEb2+CCXGIjqFXE6BQ4+rrrqqLKZynvfx62nK+4l9io0ABwEeXq/OPSryUF9kBYB6JetDdTkNQj1GiohiZJriBjHwiJtfjgy/XoCqHFlXD2AeRLHfVxwspmcVEAER4qB5RQMoxY5jLFqKHp6vJ4LMKLtlO9WAoeUYOKCAkrUPfzeywRUAUgFJc8ZMTqTWNxqvHEqy4016OcuKCUDj1kuu4IHEN/UNb3hDm9uHpm1uuY2B4vZrk9tpHR8ntpfl96j1JQ28CMcqafGHtD5VjIjnAEisI2kTf6SdjGOJtDkKRC5GzCejgFMUSqnmPv5mypvIYKBtS5YsaYcCkZ7Xo942Cb4sjiVBJLhXjHMGnCim48U4NV9P5ZWfUJRpVQlrw1sfGX6ZmMiK6SyZN56X3bR93rx5FQKUA5Wfqvk2XieWAw4W+a0UeKQYpXk+f1ashYLtgdP7DC46sxV/AfFANRPqwAQSafXiSZCxpYi8D7iP5DJSTEgxg0FRpW96+7NrMf/ok/ir/i34wPFN+ODp7VjdtxWfPbEFn6Tl4z34UJ+ZvvQElvc+iWv2r8fldMz6b+MCKFDRlH5HATIQkepcYtzQAopA0rcZV9N5nd6BVQM7cXt1J56u/gqHzUhoIOJs5OuLDAUbrdwkjE3yzjxygjmHGy3bC5LUAlh+X3au8TLtR064u+66K1hHU3MDsGbNGruS5o8ePVrYuHFj8OMGBMsq7VjW1oYri0VcalZNxfCoN6niZTN9uWrm6WSqCfaKk9tT5QUzY36TJrR+Lq0qGj+gGXPcHnPMhqlNnVMVPcWFuMwtWeVRWlzuGiYONP56Ix1Dy6QxA6DIn5DbUuvZiyuWPdB4vQFI0YAlMVN7oJkvmKcYkydPThg4tGymBcMtpl52GW6oVPBxDB8wY4LMVftWaQE+oFer+UKd7Q1pTABIRJMLsW3ySRGRb/vnBafhZX+sWc8ch6YJcx6EbBwnt+CG9nbchAkCHKYjfZWLp156ao+ZTdQDlwiuHpDi7g1pzABIpieI2M2gnBIii2f4gnB8SX2tXzZchrhN4qZ++88N17n6CtxVKuJKTDAaqGJ120KsliBx8/66SLAkKiUETXKisQAgy00Ed2FAcfwvxXVogTkPXZQtW7Z4fYfEleA0+riCUWKxdetWPPtQZe7cOad+UYDXLZqivlO4edtu3PGaC0uXdlcGriwUMcXoSu/DGCJz2W5976ev+6TgzDwtIAKMJEytzdwvRuc8Gp/UKAAyJz0xyU08c8kll3BEnQHldyKxBWFxEOfheQMeC6IWwdNrrnHPsRO4cd7yGZ9/50dn7S0VB6YMmPXlNrwFY4d6z1Txic/+18pPEHj4mjCHFpxaX+9gEeOFEpU8roAUM+GzYlWpWJT0HjsTugLnvzllTHA2c+uNgR3Y851bMMNQlzm2i6e9T+H6Zo4fxXHYuBZuPbAeF2cFXWVUX11bWSCgnbUNaayIMEvaxGTdiJbp6WFRRU+WMNHt7tI8d0QXJDHg8ZyHptsewpyFc7ADjal31/O4dsHV2HT3LZjypqW4dFIXZhfKmNvdgY9iDCjcxhWw1ox7n9uB7yz8M/S61ak01sihI2aJlXGOSIKDFSDhg7BPgTLb7Tan+3gZrXSelCL96B1br5zUjc/s/w0+9ccfnNcz+/xdDRXm/lO4bfNufIVE1cEnXnj/eVPxTxgmYIxSu+7MANYZVM81epP5vzXxWSpgtr0URpfK+I1e8097jV9or5nuNSKq50x/uefFvWd6DGgOI9TxvL7DOqKbxgAR6JTK1zauSHpBEYtnKfbrxZfwymrvbRt5hM/sME8oiaKd9uk0WvPcjtNuXV3R9SvsMSJhnRFhPSMpavq349vkrTbn0oGaSOVpO52bFLUyNMLhk0hczXvVY6kfOrSjvNGpoGqr4utcU73SlCD4VyerrywDnXSBKYRAN0reOAIN3SCzX4d085+rQeeDQfDYIcETGakgLAbDIDI+FgRX+cGT+dNI6z/6+qOlm4hzQMLvw7a7lsOx8/LWlhNhwfonfzJp6iUXHbuhrYQboEQBiQ/jE3mbmS2aG3gC55hOncbnOpfgZgNqlMvlZNeuXX6bAVJCbgZBjXQYuiYJWaXSH+Y88vq6JhF/D29g67clOidmvCzQUg7Dwsp0TRMntXvl2Znp4ONObsMNr59/bKcBz2cQ0SOqA9hH+955m9UzzgX1nh7A/QScF3/ddgWBx6xLGDwEGhq0rrOzU/ptPFHIJbKedB3vzqDrRNeIhnSyyjghXfIYeDAedR8Z/ZUZhElYRxUkeYnRdqwHb3XR57oiw5jt30FNZHSNpqgiHerA/1rO1yEHuRIQii4fqVepIEGqRyS9I2tEsxOgQjhAUAYk1zd/EzGKJDyeXmzJOJgSaUWI+JYz2+0FObABs8+bgn8zO/x5M797+jTuqCzB9XSsAdyj5lteJzb3GutoE1lDxhJqySvdFBkHZHEB3kizBjiBuJJ7GaAkFNQVyxTkhYvh8TUJRBJxH+XOGPxVtS+HLQKXvzygxRgY07kQYTKhO5Glvq6E187SB4sup/PYi3h6G246fwo2NAseonItJcNS/xk8ojZPTarYe/uP8OaTp3EbRpAGjNj64QN4B+k6NCLg4RtN4CFRZteR74ozBQR4iApOZNnB4HEeZy36ClKMxWKJkrjMGy3SqAJI6D5+eaWoNWd5vbJWVAfpjjfiapkxxzeWyvhHtOqTMZzFeJTtMYcO4369mWJZ77kWHz9yJAWuTDLPwMs79uLNR44UP0IczoDlYcPJHiZdh/xIv/ktrm1bhHe/6+/Qu2fPHqss03GGC0mdJyCjPCc8Jc5DaSc05e2k+wmOk9KVYtF1t96dc1hLP/hffNBx7OtBGWmVsSRwK89feAjnGeDcOkx95PBj38diCkVMmzatm0IUKX3F+IqeexjXNq3fGF+ROT8f4qAxa9asTrMsRwe7D8yocBos0uZ6ZhYi4qVDuihA5kAHGZpJJI9cDWAYqsyo6kBEkk1ytiEvq6xCSyb0MNWEHoj3D8UT3Gui57fd8yBuu/FfZry8f/9++92/24i/fvWr8DW9swkL7DM/PMWcVkNrzTyqe2ddOWMJfacBD9x3J2a+YOa1RzchzmNEmF3HGQG8Dye5qVCM+KkaMTeOcKHagiFXMm2vJXUTkXpNMtiRJJhivFhgGWUkunpCVmtai8PoPauG4qzb8AMsguMS3/tnzPztY3iPme+mQZ7m4XA1Op6/G4LrOC7kLS7iOMLqam9Q2REkzderikW88iToGsLefb72In9ccp/xQ1mVFStFrbo23dl0NdbTc82azi/WTGe+sV1HevCpai1iTTfdAsj4ju4fDoCMa+B+IbI65DyUlxmhyIoCB6LoUJvpEXdGvfovD5Akyey/CIxHAAHpmiTlZk8V9/GwPp8Geg4BBQ40pJP8ej3eLjlNvwPQ+eefP2m4HOj4JnyOfoeBQ1PiNKTz0JQHBn09suIjs4xHgUfXr2X1J4oBR/ZSnFBFhKk/I9hqCkCy/KV/B74Uu5l9W4uffeCb3dPhxMjdt2DGia34Smq/LbgDNQ406cxO7B0OgH77ON6tlOYONSTnidWaxYKgvuoUCjiIGxoeNLLkCQibbfJ1xwQCkJ1CRd1XppscBE+miXedL0UZRduNkr0Ag9ZOZ+9T+HA1I2B6YjO+QlaY2W8SWV2tAIa4F3E4suBowAGHfpcHhLXluI8sLkx5lKEsK6Q5cd0mVbI2Dkg1SkhZX8l479qaRJohYPCPBk8e0qELq0NQmoZRkHtoCpeiYaadPT/FwkapGkc32RjUJBJhrQLopAEfiUXKUKSBQa7jzXV3LimdB/W5TlDvjhBEksvEGikEIJGiC0h34sB4Bg9TBDxelmdYHWVVmy6tGjsIPKe24z7iEi6PZw8P1o9o/jfr8V6z/yQa5MdpSWQZC86ltHZmiK6Ywux9PKpRQsB1ZJOEiG6jp1ErivUdqfdIsaa40/ikDAW6EMvdlcliuuRYAYgtIGlOs3ndnTEaAqhfKdm/etDGs1hpliLLJ4UhXRsvra5UAFRZV1n9FbMsqaxGWoG1lYStjcc3xUSX9J7KC6r0hKCxgRkV0n16N+A6yvCjQTd4449r3mbUQNTt9J0AOCS+aHqqjhnvdJxuo0/dKJY9SCV4hK6Tqn3Xtew8jRQIeLBEdB4thphiSrEUYQBGvi/0WCAPHJ22kZG+4bMN4bgPDQJNPZOe/EEkzkhxvvuWrhmsPPM4GbHShIlOuhLt30XOyOcebrsi4ufxCjPS3Ecqy1pkZTkCU/phhq4IAFpZnpBtWaKUZDSBkuBhnUB2sUDoR6lQnk0jvYU4x8En8BEILsQcqF5pzmP3tC92gLOisI7OExNVWufxzaOQVo6z4lVAtliKiahzBqLRjMbbP61LaVeG5ckyZdWmNMhSZBou5QGlUt34Te/xk/g8pWi89k+m3WHAAAOcwqYf43UHDx60O3zvATwQO/BUP777pr/s33fgwAH//S+88IKdGiDZU4dImYh9h8iY9Pub309VTvg/Ntgp326P6CuJWJ+IwW18x080faik2bGMHsNxIB0DQ9gzh590qzxncKDDxzfjcxT3ghNBxEkObcRH2PO87k4scdu6+yPeaIrI87FCn/KeZihrS2QRxqLo0jUR9d1ExBciyzkhovtAAAcR/49oAMXD3zwDlA9p4HxjEDhWgTZR9+u1teW80VaMPa/SN4xedD8dxxWoECa7dBSKlAypnwUAinVT1WU1dFEi4Qbo9cjJU7SPIZQHVjW3tIOfdOYCfZttebIFzt01xx5zDLKerq9npq+7s524kLXI2NKi73rsHiym44mDufkUeCDymBu0ppOGQQw8sV6FOVjqkFYUNYikAq3FlxZhHfd+HdMw6Am23EIHT+v5eFDjQpZbEVied6KL5gl8Z0QtWYaHOYhx6WaYsiZLxaVivpwcOE2SBFBgfSkTPqX/CHNZO/E6N9yHRa1G13s34saIn6hLfo+L7msQpUIU2uJCxNKCEFEZomxcgmg0T5otEG2u+u3CArNt6agNXV9fX4EL7cgC6+/vL+zatcte+Aduw5Srl+HjlQo+hhYzFimnef3TePN1N0zbyxaXEYv/YL7r03KfnfuwdPE1tq5MWl9cNSGzBe28aDsjLcyshgfSKhuXdNYBlIgmUUnYyEi+qcZ23qCVu3fvLl500UVVUYlhh0sJDc7Z3PCb5A1v+dyAvY9vwjve+bfT9m37yYH3TX0V/kPvU61iXblW1WoT4tvb223xn3Av6EI/O0MNDURjg4SvhbgOSa0oZQKb3iNEUSeYctmnrC8I8cVWDyvQ1N/HTDspB6jVqHrK2Wj0HSo8rCvungKhoqLTUWWhXyzJHXHHX67vDIGiimMkJpSKf8kIPA023ynvh0xsygwcDoCaBZlT2lNpqIgHSGNR83GfyBWj0fgz7F0t1Cluk/qRv+jcgpe3mwDq3AVzYFvTkfgpzcdiqnd/13Jsb6aSYqjU348vP/Jo983XfPj4YUQ8yUSiStRXhXrXsRNZovoWE4XOaiijWq365gmyAnXFihV+H/FWPg8ebiQgS33LZRQunoWbCq6vIU17n8H73v0xHDl5El/GWaCkij2Hestv6/oDfGrFN2YdnnlBDdS62A+DVaKBcsxpFMVi0b/cdyKBh+isAkheOKKBgQGa0OsePYgiFZpeQTUiy4Nr088wp1zC38gdJ3fi05OMB+j7P8VXyWLCyFFCXOdnD3W/6e3Xz163/tuYuub2HTc9vw5f2LFto+1uzztSI3M+htdxKTH9/1KpZNfRvHmgcoW5BeKedV7nMaBJeZ5Z+SRFdNmyZTqJzMe+dNMon3phPNHmV7qPjpAuZCL4z1GcbXI3On75n5juGnL6HGuXSluW507/hf8bcV3zoBQc97VcGLmXuTVi1u0uHnMh6zxUIPLKp/BAt4k0DmuBmZtZyQpNkBX23S/W8pSHaZFVT27Bl4xvafoF56HTzP99NUzOr57ZiV/uexTzBNBTjkPx/yyI+CEqTDTZdTaJwSOaaJL4CsIX+r1ddFMkcORQgdM0F9qEm6dPn9Z9fHNz7XtjXIfCIEYcdj7zMyw6EybnV0/vwNNHe8pvhYh5ORDpBDHPbQT3hZjm1AzRxaMnkS+a40SB+HJPaqwCI4h9LVo0r3KmQbUFcZ5vrsLMu7/W1SoXqp7ajnspGPt7U9F1bFOtglVsP0SvdEJGgrwUYe4BKTJwyJzneeSpGa1RIlr48kVUHCirAjV4oRtc7nMzYDjWg5tJF+prngsdoliX0XG7fnQrZpoY2H1yu+E6a3atrcxHpMkln7d4COxDQf9V6Dz6NeTIqQlS+o+8oAEHikTdPYBEVUOFXubWlBgiLvQFzKScIBJJjUTW1gfxxq5OdG68vxZ9l1ypbytWu+CpBY87n6B+Xb9uksBED4nSebLifjllkeA++kLap5UutI68O30i0H+IA3VU0N5MD0TJhUgXMpH2zHzn09uwlkBm9J0uylSUIouARcn6sV6FCJXmWCGgt8JEGU0OnFaIOY9j7YHVJUHj1qWaJykFuvL8o1jagj7juRBq7VtSetOJzdbh2EXg0SEQA56ntz1UWQBRaRFrcCn1HtUAXSbJA+EDlFMzlKjG4UJ5LtRRmlOJY6z/ZDVTaMSFikYX2hemq1bJT0QZi1Mmo1uDx/iYvuViXUGZTkYbFv0ed/+wIC2yct2nWUrSRf3WEmEORE+ifrsO6xORl91W5s+b09Fq+TFzoe9/oWsmJYs5LlT93VO43oCqa9GC6d3aISn0nWgvH6TFlx/KpxXNOsg5UJMUYdsxURZ7RVOg/3DqRqviK+BCm2oWGfl2CDyzZ8/qvP1fcaGytKrkN4JqBKXznQW4o4WBksu6gdx8HwJJDqQsLxnCkOApqaT0oO6d/C9DBRBxIVeh0XXhhTOsma5enFLt7cGHIYCjKkyjyfJQ3Efoe/Z/MnDYA59T66RZtzbbS6rc11pgIlHL3kQTeW/oPGxkplNXVhJb/02cJw4eWZqcVWWqLa+g0oI5LJMMXeS6T5PEJqv0e9A8e2Zl0pgSX6mSZb6Zz/wUC4cFnnvas8BzaN9aLIVqv4vsN+NEa9qlXgcHFun3cnk/yKkJEj1p7DKlMjB44AAkRRgHItn3I7iPV6CPPGO7jA0JPNQMoVhEJ4FnQIPn0Rp4EKkudb/dxjE5pAsEtdJcFBwnUKLzosDWyV88fZEleJT3OVr31TZE8WXBc1/7ItJ5bo9wnt0Pt12BdA/DoCULlN7D4lb6e+j/uGXmNAWlNE+MXjyjRfLi8SodPOWLHgMQP/083W2ceUPlPOb4DM7TtpRFlqpvj5rrDkxe5Gq/DwOK/qfzPAeiLLe8WqCY+Y6M5DGkzXcaXv9oa0N7VuJYnXFop+sedsnimV2n64st3/wbYcVHzOKK6j8I43qB8ixTWHJqkiKWRypwClXzzvoPwpvY3mzkPSKaOqe+Cl39WwPwSWsrWtsOpcjLRDH1ms1Yt1QA6YahOfdpnoKUVSbUARDdEAUeD6JKe3baasao7l4H2znMgic8tnqkp2TBwyJLdxKLNK6S3DFVnhyzvACkuE6u/7RAMtuO9QG4i6x8JZnKM3EDEl0v/R8ubwU85GFGfc4TeJgjjkL9dhzv4GSwyO7w/J/4YZGcNxddQyevOHMWIpz+o73PkbiXHQSeZ9diQQtxL8tdyFT//VejMwaeWCMoxLlOVOehc5U6HP8ffkikzycZfIFwDqBWSOf86MQxmfMsLTApwtrb0Pb8Y5jfCngIIAQem0W4E/fGOA8HR7WXOaOfT0mdY5YbIhosTSZC/+VzQbJcRfa9USEMbQZ7EXb55Ze1DB7iPOUSOu7+Kmbo8MSRzfgQhKKsXzUQy+3hc9INMKUjFBnAAfJSneFQFvcJOpBldZ43o+2RH+CCFsBziGq1CDxUNaFN9ZeeKC9HyHGi76mQmY8xJyGQKjuSxgH/b4j/ipyGToE1wiJNPL3RxHm6ibOmo9yst5mchD0/wsIliy+uEHgU6A7tX4/L1ctN2lV4JBpV1znNAkg+NMG6jfY28wXI9Z7hUcDKVVwoK4Ba7qigbEDR1BsIqTLioa9j2pTJqOx/HEsleBhYiCjLkR6GQWgCaSehNNED8IjiSPmfcxouqSfSg6hOEpnlPgc24OJm9B3KFFywYF7lvKnocFWiAVfi/GWoLvFNeJYldwxEluA0QWWJsLJy8IwQBX4QNbwVJr257OU1outbjUTWS0/iGnIsPnYHpvVvw5c1V/r5v+MCRCLpyPAqIxKWkLpPLC0DSNX25zSSpJVn5YVOWWJwN7FOmc6hU9ux6sk7cf55r0b7/sfblup6LapdR5i5mPIsq0SwIKIuCwGZ87CPJ4uj0n/NATTy5Fl6LA4mdAmtA5Vi4sqMH+5ai/mTutA2d5bvAR2Aq29r6YOI6zepkdH8IBWegDDTpbiKgCmnESZvzrLOI1M4ZCd6KEvMcKDdDjSHTm/Drft+iXkEnD99x2vpbYTLq7uCqlLbEWPXLzAfGf2ZGUiR10gGTkKooKjQ1VKOwTyn+exTEMKA0n+UI07rHeXeDZWLaWqsq/JrZqH9WA+uiZj1h05sKXJjA10hkQpJENeRIFJ+Hs955Ps5kO0YzAHUJBUxNPJt61zXMb/eLCelUsnfAPOkW9lG7W8PHjxo10/9o1N7X78YhRcfwVXP/g9+0dWFB0144kr+jmqCNS8cxNK3vP8Pv0S9obnlHVHW/Nq1a4MTdG/HSbjNLndEE62Gkwb/L6ezTar7VsCFEKZ/pmJi1fSbla24OtqDt0JxGCGqZDS/LN0DmuNE4lraW04kOSiQc56WaagcyF501wMxeO8VxNNLvRCpB6JsqumIuMzTYn7N8RNYXl6A5ZNfh7UGEEHzbtHU26+jD+JoBlgF4j7Ecai7vWt2aRt98++6qcVKQXSKpXnqWyjTeZDTqFFgvdCKJP42wphFVup9pnLRwHZ8sW9z+WpEGi3I7EXmPioIqnWrqKUlTXROv+DzZ8dhHtMafYqJrsCUl1ZOpLFCyjqDSjrTBYgIY1g+5VSKLpkABoTlN24+BaDcw3xuyOsOklBHH0IkxUN6qlXlaipmpbmMXGbgsFNQtpTR56a7pubc5xwRP7mitIVWS+ei5ELShPYjlu4RAYYFh+BIxSyRxb/LUy6xSSLv6UJOY4a0+JIxpSDHRvqHlFjL8hnZwdYcgYjmGUy6dIgBKrmMcApqLpnTGKBCvSHTO2QjbsRFmwdQDFwNEr+k6JK/HUzz9NMxSBm6j/S3BB5qmXiPNCBSYkkqx1LXQVwsBpxHBnyTwXerI6cxRLozWaEQT//M6OalRVtU+VZVHlbHkTG4LEWezk28Zhs5jUHSXVkj74bQIi1TqUYEOKJhd9QshwNnTJl355frO2OZVEtbDRbIZd0ORUXtYyN4z7zkMhK0cr10bCJXlscd+Zun82tkRafWT6SCrdvGybfeiB7TqUoQ2S0MOXBGjUbyQke/K6mR3caxKBeDsu/QcvtEjzPbU7pLEr64178RkPd123OFZ5SoiJEj/3ZivsGF2kvXbNB19erVHgyUAuLe4BN9CRuDTKWKyDce+1UY1L2aSdPIaTyQFFey+VI9kx/KBIfSpbRJrnQh/7vIaWKQBI6jQiR/CNr81oWKTrcJdCr3/QDC3B7kNDFJW2kSJDpWJVvG6HVA3oP5FUlatDBXUt7hmP8odnwOoJxyyimnnHLKKaeccsopp5xyyimnnHLKKaeccsopp5yaof8HNm7YNmN9ZjUAAAAASUVORK5CYII='
            }
          }
        }
      },
      'labelLayout': {
        'x': '74.5%',
        'y': '46%'
      },
      'labelLine': {
        'show': false
      },
      'data': [{
        'value': confirmedCount
      }, {
        'value': unFinishedCountGauge
      }, {
        // make an record to fill the bottom 50%
        'value': confirmedCount + unFinishedCountGauge,
        'itemStyle': {
          // stop the chart from rendering this piece
          'color': 'none',
          'decal': {
            'symbol': 'none'
          }
        },
        'label': {
          'show': false
        }
      }]
    }, {
      'type': 'gauge',
      'z': 2,
      'startAngle': 180,
      'endAngle': 0,
      'min': 0,
      'max': confirmedCount + unFinishedCountGauge,
      'splitNumber': 4,
      'itemStyle': {
        'color': !(confirmedCount === 0 && unFinishedCount === 0) && unFinishedCount === 0 ? '#FEDB00' : '#004EA8'
      },
      'progress': {
        'show': true,
        'width': 52,
        'itemStyle': {
          'color': '#004EA800'
        }
      },
      'pointer': {
        'icon': 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
        'length': '8%',
        'width': 6,
        'offsetCenter': ['0%', '-32%']
      },
      'axisLine': {
        'lineStyle': {
          'width': 52,
          'color': [[1, '#F4F4F4']]
        }
      },
      'axisTick': {
        'splitNumber': 2,
        'lineStyle': {
          'width': 2,
          'color': '#999'
        }
      },
      'splitLine': {
        'show': false
      },
      'axisLabel': {
        'show': false
      },
      'title': {
        'offsetCenter': ['0%', '-16%'],
        'textStyle': {
          'fontSize': 12,
          'color': '#666'
        }
      },
      'detail': {
        'width': '40%',
        'offsetCenter': [0, '12%'],
        'valueAnimation': true,
        'color': '#004EA8',
        'formatter': [confirmedCount, confirmedCount - tppTargetCount > 0 ? "{excessNumber|+".concat(confirmedCount - tppTargetCount, "}") : ''].join('\n'),
        'rich': {
          'excessNumber': {
            'color': '#FEDB00',
            'fontSize': 12,
            'lineHeight': 18,
            'fontWeight': 600
          }
        }
      },
      'data': [{
        'value': confirmedCount,
        'name': _main.default.$t('storeComponents.common.numberOfConfirmations')
      }]
    }]
  };
  // UI
  $echart && $echart.setOption(options);
};
var drawMoney = exports.drawMoney = function drawMoney($echart, data) {
  var _data$finishRate = data.finishRate,
    finishRate = _data$finishRate === void 0 ? 0 : _data$finishRate,
    _data$unFinishRate = data.unFinishRate,
    unFinishRate = _data$unFinishRate === void 0 ? 100 - finishRate : _data$unFinishRate,
    _data$dataValue = data.dataValue,
    dataValue = _data$dataValue === void 0 ? '' : _data$dataValue;
  var isShowLabel = false;
  if (finishRate > 100) {
    finishRate = 100;
    unFinishRate = 0;
    isShowLabel = true;
  }
  var options = {
    'series': [{
      'name': 'Access From',
      'type': 'pie',
      'radius': ['75%', '94%'],
      'color': ['#004EA8', '#FEDB00'],
      'startAngle': 180,
      'silent': true,
      'itemStyle': {
        'borderRadius': 4
      },
      'label': {
        'show': isShowLabel,
        'position': 'inner',
        'formatter': '{img|}',
        'rich': {
          'img': {
            'width': 28,
            'height': 28,
            'backgroundColor': {
              'image': 'data:image/png;base64,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'
            }
          }
        }
      },
      'labelLayout': {
        'x': '72.5%',
        'y': '46%'
      },
      'labelLine': {
        'show': false
      },
      'data': [{
        'value': finishRate
      }, {
        'value': unFinishRate
      }, {
        // make an record to fill the bottom 50%
        'value': finishRate + unFinishRate,
        'itemStyle': {
          // stop the chart from rendering this piece
          'color': 'none',
          'decal': {
            'symbol': 'none'
          }
        },
        'label': {
          'show': false
        }
      }]
    }, {
      'type': 'gauge',
      'z': 2,
      'startAngle': 180,
      'endAngle': 0,
      'min': 0,
      'max': finishRate + unFinishRate,
      'splitNumber': 4,
      'radius': "100%",
      'itemStyle': {
        'color': finishRate === 100 ? '#FEDB00' : '#004EA8'
      },
      'progress': {
        'show': true,
        'width': 52,
        'itemStyle': {
          'color': '#004EA800'
        }
      },
      'pointer': {
        'icon': 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
        'length': '8%',
        'width': 6,
        'offsetCenter': ['0%', '-32%']
      },
      'axisLine': {
        'lineStyle': {
          'width': 52,
          'color': [[1, '#F4F4F4']]
        }
      },
      'axisTick': {
        'splitNumber': 2,
        'lineStyle': {
          'width': 2,
          'color': '#999'
        }
      },
      'splitLine': {
        'show': false
      },
      'axisLabel': {
        'show': false
      },
      'title': {
        'offsetCenter': ['0%', '-16%'],
        'textStyle': {
          'fontSize': 12,
          'color': '#666'
        }
      },
      'detail': {
        'width': '40%',
        'offsetCenter': [0, '15%'],
        'valueAnimation': true,
        'color': dataValue == '' ? 'transparent' : '#004EA8',
        'formatter': [dataValue].join('\n'),
        'rich': {
          'excessNumber': {
            'color': '#fff',
            'fontSize': 0,
            'lineHeight': 18,
            'fontWeight': 600
          }
        }
      },
      'data': [{
        'value': finishRate
      }]
    }]
  };
  // UI
  $echart && $echart.setOption(options);
};

// 月度实际销售情况 绘图
var drawMonthly = exports.drawMonthly = function drawMonthly($echart, data) {
  var monthXAxisData = data.monthXAxisData,
    monthSeriesData = data.monthSeriesData;
  var options = {
    'tooltip': {
      'trigger': 'axis',
      'axisPointer': {
        'type': 'shadow'
      },
      formatter: function formatter(params) {
        var str = '';
        var total = 0;
        var tppNum = 0;
        for (var i = 0; i < params.length; i++) {
          if (params[i].seriesName !== _main.default.$t('storeVisitReport.TPPRCommon.TPPInfo')) {
            total += params[i].value;
          } else if (params[i].seriesName == _main.default.$t('storeVisitReport.TPPRCommon.TPPInfo')) {
            tppNum = params[i].value;
          }
        }
        str += "<div style=\"font-size: 12px; color: #222; font-weight: bold;\">" + params[0].axisValue + "</div>";
        str += "<div style=\"font-size: 10px; color: #333; line-height: 1.4;\">" + _main.default.$t('storeVisitReport.TPPRCommon.TPPInfo') + "<span style=\"margin-left: 4px; font-weight: bold;\">" + tppNum + "</span></div>";
        str += "<div style=\"font-size: 10px; color: #333; line-height: 1.4;\">" + _main.default.$t('storeComponents.table.row1') + "<span style=\"margin-left: 4px; font-weight: bold;\">" + total + "</span></div>";
        for (var i = 0; i < params.length; i++) {
          if (params[i].seriesName == _main.default.$t('storeVisitReport.TPPRCommon.TPPInfo')) {
            continue;
          } else {
            str += "<div style=\"display: flex; align-items: center; justify-content: space-between; width: 90px; font-size: 10px; font-weight: bold;\">\n                      <div style=\"margin-right: 8px;\n                        flex: none;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        width: 26px;\n                        height: 16px;\n                        color: #fff;\n                        line-height: 1;\n                        background-color: " + params[i].color + ";\n                        border-radius: 2px;\">" + params[i].seriesName + "</div>\n                      <div style=\"width: 100%; color: #333;\">" + params[i].value + "</div>\n                      <div style=\"color: #666;\">" + (total > 0 ? (params[i].value * 100 / total).toFixed(0) : 0) + "%</div>\n                    </div>";
          }
        }
        return str;
      }
    },
    'color': ['#004EA8', '#A7CAF2', '#FEDB00', '#999EA7'],
    'legend': {},
    'grid': {
      'left': '3%',
      'right': '4%',
      'bottom': '3%',
      'containLabel': true
    },
    'xAxis': monthXAxisData,
    'yAxis': [{
      'type': 'value'
    }],
    'series': monthSeriesData
  };
  // UI
  $echart && $echart.setOption(options);
};

// 季度实际销售情况 绘图
var drawQuarter = exports.drawQuarter = function drawQuarter($echart, data) {
  var quarterXAxisData = data.quarterXAxisData,
    quarterSeriesData = data.quarterSeriesData;
  var options = {
    'tooltip': {
      'trigger': 'axis',
      'axisPointer': {
        'type': 'shadow'
      },
      formatter: function formatter(params) {
        var str = '';
        var total = 0;
        var tppNum = 0;
        for (var i = 0; i < params.length; i++) {
          if (params[i].seriesName !== _main.default.$t('storeVisitReport.TPPRCommon.TPPInfo')) {
            total += params[i].value;
          } else if (params[i].seriesName == _main.default.$t('storeVisitReport.TPPRCommon.TPPInfo')) {
            tppNum = params[i].value;
          }
        }
        str += "<div style=\"font-size: 12px; color: #222; font-weight: bold;\">" + params[0].axisValue + "</div>";
        str += "<div style=\"font-size: 10px; color: #333; line-height: 1.4;\">" + _main.default.$t('storeVisitReport.TPPRCommon.TPPInfo') + "<span style=\"margin-left: 4px; font-weight: bold;\">" + tppNum + "</span></div>";
        str += "<div style=\"font-size: 10px; color: #333; line-height: 1.4;\">" + _main.default.$t('storeComponents.table.row1') + "<span style=\"margin-left: 4px; font-weight: bold;\">" + total + "</span></div>";
        for (var i = 0; i < params.length; i++) {
          if (params[i].seriesName == _main.default.$t('storeVisitReport.TPPRCommon.TPPInfo')) {
            continue;
          } else {
            str += "<div style=\"display: flex; align-items: center; justify-content: space-between; width: 90px; font-size: 10px; font-weight: bold;\">\n                      <div style=\"margin-right: 8px;\n                        flex: none;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        width: 26px;\n                        height: 16px;\n                        color: #fff;\n                        line-height: 1;\n                        background-color: " + params[i].color + ";\n                        border-radius: 2px;\">" + params[i].seriesName + "</div>\n                      <div style=\"width: 100%; color: #333;\">" + params[i].value + "</div>\n                      <div style=\"color: #666;\">" + (total > 0 ? (params[i].value * 100 / total).toFixed(0) : 0) + "%</div>\n                    </div>";
          }
        }
        return str;
      }
    },
    'color': ['#004EA8', '#A7CAF2', '#FEDB00', '#999EA7'],
    'legend': {},
    'grid': {
      'left': '3%',
      'right': '4%',
      'bottom': '3%',
      'containLabel': true
    },
    'xAxis': quarterXAxisData,
    'yAxis': [{
      'type': 'value'
    }],
    'series': quarterSeriesData
  };
  // UI
  $echart && $echart.setOption(options);
};

// 首页销售 绘图
var drawSales = exports.drawSales = function drawSales($echart, data) {
  var _data$finishSalesRate = data.finishSalesRate,
    finishSalesRate = _data$finishSalesRate === void 0 ? 0 : _data$finishSalesRate,
    _data$finishSeventeen = data.finishSeventeenRate,
    finishSeventeenRate = _data$finishSeventeen === void 0 ? 0 : _data$finishSeventeen,
    _data$finishEighteenR = data.finishEighteenRate,
    finishEighteenRate = _data$finishEighteenR === void 0 ? 0 : _data$finishEighteenR;
  var barGap = 0.34;
  var options = {
    graphic: {
      elements: [
      // 每个进度条上的label，共3个。
      // 不要删除text内的空格，是用于调整位置的。
      {
        type: 'text',
        left: 'center',
        top: 30,
        z: 100,
        style: {
          fill: '#fff',
          text: "   ".concat(_main.default.$t('storeComponents.charts.total')),
          font: '500 14px PingFang SC'
        }
      }, {
        type: 'text',
        left: 'center',
        top: 60,
        z: 100,
        style: {
          fill: '#000',
          text: '   17+',
          font: '400 14px PingFang SC'
        }
      }, {
        type: 'text',
        left: 'center',
        top: 91,
        z: 100,
        style: {
          fill: '#000',
          text: '   18+',
          font: '400 14px PingFang SC'
        }
      }]
    },
    polar: {
      radius: [30, '90%']
    },
    angleAxis: {
      max: 100,
      startAngle: 90,
      splitLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    radiusAxis: {
      type: 'category',
      show: false
    },
    color: ['#FEDB00', '#95CCFF', '#004EA8'],
    // 由内向外铺
    series: [{
      type: 'bar',
      data: [finishEighteenRate > 100 ? 100 : finishEighteenRate],
      coordinateSystem: 'polar',
      roundCap: true,
      showBackground: true,
      backgroundStyle: {
        color: '#F4F4F4'
      },
      barGap: barGap
    }, {
      type: 'bar',
      data: [finishSeventeenRate > 100 ? 100 : finishSeventeenRate],
      coordinateSystem: 'polar',
      roundCap: true,
      showBackground: true,
      backgroundStyle: {
        color: '#F4F4F4'
      },
      barGap: barGap
    }, {
      type: 'bar',
      data: [finishSalesRate > 100 ? 100 : finishSalesRate],
      coordinateSystem: 'polar',
      roundCap: true,
      showBackground: true,
      backgroundStyle: {
        color: '#F4F4F4'
      },
      barGap: barGap
    }]
  };
  // UI
  $echart && $echart.setOption(options);
};
var drawSalesSalesLeader = exports.drawSalesSalesLeader = function drawSalesSalesLeader($echart, data) {
  var _data$finishSalesRate2 = data.finishSalesRate,
    finishSalesRate = _data$finishSalesRate2 === void 0 ? 0 : _data$finishSalesRate2,
    _data$finishLUXRate = data.finishLUXRate,
    finishLUXRate = _data$finishLUXRate === void 0 ? 0 : _data$finishLUXRate,
    _data$finishSUVRate = data.finishSUVRate,
    finishSUVRate = _data$finishSUVRate === void 0 ? 0 : _data$finishSUVRate,
    _data$finishEVRate = data.finishEVRate,
    finishEVRate = _data$finishEVRate === void 0 ? 0 : _data$finishEVRate;
  var barGap = 0.34;
  var options = {
    graphic: {
      elements: [
      // 每个进度条上的label，共3个。
      // 不要删除text内的空格，是用于调整位置的。
      {
        type: 'text',
        left: 'center',
        top: 26,
        z: 100,
        style: {
          fill: '#fff',
          text: "   ".concat(_main.default.$t('storeComponents.charts.total')),
          font: '500 14px PingFang SC'
        }
      }, {
        type: 'text',
        left: 'center',
        top: 50,
        z: 100,
        style: {
          fill: '#000',
          text: '   LUX',
          font: '400 14px PingFang SC'
        }
      }, {
        type: 'text',
        left: 'center',
        top: 71,
        z: 100,
        style: {
          fill: '#000',
          text: '   SUV',
          font: '400 14px PingFang SC'
        }
      }, {
        type: 'text',
        left: 'center',
        top: 95,
        z: 100,
        style: {
          fill: '#000',
          text: '   EV',
          font: '400 14px PingFang SC'
        }
      }]
    },
    polar: {
      radius: [30, '90%']
    },
    angleAxis: {
      max: 100,
      startAngle: 90,
      splitLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    radiusAxis: {
      type: 'category',
      show: false
    },
    color: ['#FEDB00', '#FFBF60', '#95CCFF', '#004EA8'],
    // 由内向外铺
    series: [{
      type: 'bar',
      data: [finishEVRate > 100 ? 100 : finishEVRate],
      coordinateSystem: 'polar',
      roundCap: true,
      showBackground: true,
      backgroundStyle: {
        color: '#F4F4F4'
      },
      barGap: barGap
    }, {
      type: 'bar',
      data: [finishSUVRate > 100 ? 100 : finishSUVRate],
      coordinateSystem: 'polar',
      roundCap: true,
      showBackground: true,
      backgroundStyle: {
        color: '#F4F4F4'
      },
      barGap: barGap
    }, {
      type: 'bar',
      data: [finishLUXRate > 100 ? 100 : finishLUXRate],
      coordinateSystem: 'polar',
      roundCap: true,
      showBackground: true,
      backgroundStyle: {
        color: '#F4F4F4'
      },
      barGap: barGap
    }, {
      type: 'bar',
      data: [finishSalesRate > 100 ? 100 : finishSalesRate],
      coordinateSystem: 'polar',
      roundCap: true,
      showBackground: true,
      backgroundStyle: {
        color: '#F4F4F4'
      },
      barGap: barGap
    }]
  };
  // UI
  $echart && $echart.setOption(options);
};

// 销量线型图
var drawLineSales = exports.drawLineSales = function drawLineSales($echart, salesForm, saleEchartsData) {
  $echart.clear();
  var xAxis = [];
  if (salesForm.type === '1') {
    xAxis = new Array(31).toString().split(',').map(function (t, i) {
      return i + 1;
    });
  } else if (salesForm.type === '2') {
    var quarter = parseInt(salesForm.value.substring(4));
    var monthByQuarter = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [10, 11, 12]];
    xAxis = monthByQuarter[quarter - 1];
  } else if (salesForm.type === '3') {
    xAxis = new Array(12).toString().split(',').map(function (t, i) {
      return i + 1;
    });
  }
  var options = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      itemWidth: 8,
      itemHeight: 8,
      itemGap: 16,
      right: '0%',
      data: saleEchartsData.chartNameList
    },
    xAxis: {
      type: 'category',
      data: xAxis
    },
    yAxis: {
      type: 'value'
    },
    grid: {
      top: '16%',
      left: '14%',
      right: '2%'
    },
    series: saleEchartsData.series
  };
  $echart.setOption(options);
};

// 获取当前时间相关 月份、季度、年份
var getCurDateTree = exports.getCurDateTree = function getCurDateTree() {
  var myDate = new Date();
  var curFullYear = myDate.getFullYear(); // 获取完整的年份(4位,1970-????)
  var curMonth = myDate.getMonth() + 1; // 获取当前月份(0-11,0代表1月)
  var currQuarter = Math.floor(curMonth % 3 === 0 ? curMonth / 3 : curMonth / 3 + 1);
  // console.log(9999, curFullYear, curMonth, currQuarter)
  return {
    year: curFullYear + '',
    month: "".concat(curFullYear).concat((0, _utils.addZero)(curMonth)),
    quarter: "".concat(curFullYear).concat((0, _utils.addZero)(currQuarter))
  };
};